/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import Select from "react-select";
/**
 * A customized Select component that prevents the menu from reopening when display is cleared.
 */
class CustomSelect extends Select {
  attachClearIndicatorTouchEndHandler = (ref) => {
    if (ref) {
      // eslint-disable-next-line no-param-reassign
      ref.select.onClearIndicatorTouchEnd = () => {
        ref.onChange(null);
      };
    }
  };

  render() {
    const { isClearable, value, ...rest } = this.props;
    // we set selected option to null so that react-select defaults to showing the placeholder message
    // see github issue for more details: https://github.com/JedWatson/react-select/issues/2931#issuecomment-608091653
    let cleanValue = value;
    if (!value.value) {
      // cleanValue = { value: null, label: null };
      cleanValue = null;
    }
    return (
      <Select
        ref={isClearable && this.attachClearIndicatorTouchEndHandler}
        isClearable={isClearable}
        value={cleanValue}
        {...rest}
      />
    );
  }
}

export default CustomSelect;
